'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);

var _MessagesList = require('./MessagesList.scss');var styles = _interopRequireWildcard(_MessagesList);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var MessagesList = function MessagesList(_ref)








{var _ref$messages = _ref.messages,messages = _ref$messages === undefined ? [] : _ref$messages,translate = _ref.translate,onAdd = _ref.onAdd,onDelete = _ref.onDelete,onToggleMore = _ref.onToggleMore,onEdit = _ref.onEdit,isOwner = _ref.isOwner,isOpen = _ref.isOpen;
  var list = isOpen ? messages : messages.slice(0, 2);
  return (
    _react2.default.createElement('div', { className: styles.messages },
      isOwner &&
      _react2.default.createElement('div', null,
        _react2.default.createElement('button', { type: 'button', className: styles.transparentButton, onClick: onAdd },
          _react2.default.createElement('span', { className: 'icon icon-add' }),
          _react2.default.createElement('p', null, translate('propertyDetails', 'addMore')))),



      list.map(function (message) {
        var handleEdit = function handleEdit() {return onEdit(message);};

        var handleDelete = function handleDelete() {return onDelete(message);};

        return (
          _react2.default.createElement('div', { key: message.id, className: styles.container },
            _react2.default.createElement('div', { className: styles.messageWrapper },
              _react2.default.createElement('p', { className: styles.date },
                (0, _moment2.default)(message.created_at).
                format('DD.MM.YYYY')),

              _react2.default.createElement('div', { className: styles.messageBlock },
                _react2.default.createElement('p', { className: styles.message },
                  message.message),

                isOwner &&
                _react2.default.createElement('div', null,
                  _react2.default.createElement('button', { type: 'button', onClick: handleEdit, className: styles.controls },
                    _react2.default.createElement('i', { className: 'icon icon-edit' })),

                  _react2.default.createElement('button', { type: 'button', onClick: handleDelete, className: styles.controls },
                    _react2.default.createElement('i', { className: 'icon icon-delete-property' })))))));







      }),

      messages.length > 2 &&
      _react2.default.createElement('button', { type: 'button', className: styles.transparentButton, onClick: onToggleMore },
        _react2.default.createElement('p', null,
          !isOpen ? translate('propertyDetails', 'seeAll') : translate('propertyDetails', 'hideDescription')),

        _react2.default.createElement('i', { className: 'icon icon-arrow-' + (!isOpen ? 'down' : 'up') }))));




};exports.default =

MessagesList;
MessagesList.propTypes = {
  messages: _propTypes2.default.array,
  translate: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  onEdit: _propTypes2.default.func,
  onAdd: _propTypes2.default.func,
  onToggleMore: _propTypes2.default.func,
  isOwner: _propTypes2.default.bool,
  isOpen: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetailedInfo/MessageFromCompany/components/MessagesList/MessagesList.js
// module id = 2818
// module chunks = 0